import {
  API_GET_STREAMERS_ENDPOINT,
  API_SWITCH_AUCTION_STREAMERS_ENDPOINT,
  API_SWITCH_LANE_STREAMERS_ENDPOINT,
  API_RESET_ENGINE_CACHE_ENDPOINT,
  API_RESET_AUCTION_ENDPOINT,
  API_RELOAD_AUCTION_ENDPOINT,
  API_RESET_LANE_ENDPOINT,
  API_REBOOT_STREAMER_ENDPOINT,
  API_SEND_SYSTEM_MESSAGE_ENDPOINT,
} from '../../shared/constants';

export const engineToolType = {
  getStreamers: 'GET_STREAMERS',
  switchAuctionStreamers: 'SWITCH_AUCTION_STREAMERS',
  switchLaneStreamers: 'SWITCH_LANE_STREAMERS',
  resetEngineCache: 'RESET_ENGINE_CACHE',
  resetLane: 'RESET_LANE',
  reloadAuction: 'RELOAD_AUCTION',
  resetAuction: 'RESET_AUCTION',
  rebootStreamer: 'REBOOT_STREAMER',
  sendSystemMessage: 'SEND_SYSTEM_MESSAGE',
  sendSystemMessageForceAllBiddersReload: 'FORCE_ALL_BIDDERS_RELOAD',
  sendSystemMessageForceAllClerksReload: 'FORCE_ALL_CLERKS_RELOAD',
};

export default (type) => {
  const {
    getStreamers,
    rebootStreamer,
    reloadAuction,
    resetAuction,
    resetEngineCache,
    resetLane,
    switchAuctionStreamers,
    switchLaneStreamers,
    sendSystemMessage,
    sendSystemMessageForceAllBiddersReload,
    sendSystemMessageForceAllClerksReload,
  } = engineToolType;
  switch (type) {
    case getStreamers:
      return {
        fn: API_GET_STREAMERS_ENDPOINT,
        body: {},
        processData: async (res) => {
          const {
            data: { streamers },
          } = res;
          return streamers;
        },
      };
    case switchAuctionStreamers:
      return {
        fn: API_SWITCH_AUCTION_STREAMERS_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case switchLaneStreamers:
      return {
        fn: API_SWITCH_LANE_STREAMERS_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case resetEngineCache:
      return {
        fn: API_RESET_ENGINE_CACHE_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case sendSystemMessage:
      return {
        fn: API_SEND_SYSTEM_MESSAGE_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case sendSystemMessageForceAllBiddersReload:
      return {
        fn: API_SEND_SYSTEM_MESSAGE_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case sendSystemMessageForceAllClerksReload:
      return {
        fn: API_SEND_SYSTEM_MESSAGE_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case resetAuction:
      return {
        fn: API_RESET_AUCTION_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case resetLane:
      return {
        fn: API_RESET_LANE_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case reloadAuction:
      return {
        fn: API_RELOAD_AUCTION_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    case rebootStreamer:
      return {
        fn: API_REBOOT_STREAMER_ENDPOINT,
        body: {},
        processData: async (res) => res.data,
      };
    default:
      throw new Error('Invalid engine tool type passed to engineTools reducer');
  }
};
